import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContextService {
  organizationId!: string;
  activityId!: string;
  group: string | undefined;
  urlToken: string | undefined;
  token: string | undefined;

  initialize(organizationId: string, activityId: string, group?: string, urlToken?: string, token?: string) {
    this.organizationId = organizationId;
    this.activityId = activityId;
    this.group = group;
    this.urlToken = urlToken;
    this.token = token;
  }
}
